export default __webpack_public_path__ + "static/media/iniciotramite.23c4ee31.jpeg";